import React, { useEffect, useState } from 'react';
import { useApolloClient } from '@apollo/client';
import { SEARCH } from './api';
import { diningStrings as S } from '../../content/dining';
import { getPublicErrorMessage } from '../../utils/errors';

/** Debounced transient provider search. Late responses cannot replace the current query's results. */
export default function DiningPlaceSearch({ onSelect, disabled, sessionToken, savedPlaceIds = new Set() }) {
  const client = useApolloClient();
  const [query, setQuery] = useState(''); const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false); const [error, setError] = useState('');
  const [searched, setSearched] = useState(false);
  useEffect(() => {
    let current = true; setResults([]); setError(''); setSearched(false);
    if (query.trim().length < 2) { setLoading(false); return; }
    setLoading(true);
    const timer = setTimeout(async () => {
      try {
        const { data } = await client.query({ query: SEARCH, variables: { query: query.trim(), sessionToken }, fetchPolicy: 'no-cache' });
        if (current) { setResults(data.searchDiningPlaces); setSearched(true); }
      } catch (failure) { if (current) setError(getPublicErrorMessage(failure)); }
      finally { if (current) setLoading(false); }
    }, 400);
    return () => { current = false; clearTimeout(timer); };
  }, [query, client, sessionToken]);
  return <section className="recipe-detail-panel dining-search"><h3>{S.findPlace}</h3>
    <input aria-label={S.findPlace} type="search" maxLength={180} placeholder={S.searchPlaceholder} value={query} disabled={disabled} onChange={e => setQuery(e.target.value)} />
    {loading && <div className="dining-search-skeleton" aria-label={S.searching} role="status" />}
    {results.length > 0 && <div className="dining-search-results">{results.map(result => <button type="button" disabled={disabled} key={result.id} onClick={() => onSelect(result)}><strong>{result.name}</strong><span>{result.address}</span>{savedPlaceIds.has(result.id) && <span>{S.inYourDiningSpots}</span>}</button>)}<span className="dining-attribution" translate="no">Google Maps</span></div>}
    {searched && !results.length && <p>{S.noSearchResults}</p>}
    {error && <p role="alert" className="error-copy">{error}</p>}
  </section>;
}
